import axios from 'axios'
import { trackPromise } from 'react-promise-tracker'

/** Done */
export const getPOList = async (app, filter) => {
    let po_list = null 
    app.startLoadingIndicator()
    if (filter) {
        await trackPromise (
            //axios.post(app.API_URI + '/po', filter)
            axios.get(app.API_URI + `/purchaseorders/filter?dc_from=${filter.date.date_created_from}&dc_to=${filter.date.date_created_to}&dp_from=${filter.date.date_prepared_from}&dp_to=${filter.date.date_prepared_to}`)
            .then(result => {
                po_list = result.data
                app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    } else {
        await trackPromise (
            axios.get(app.API_URI + '/purchaseorders')
            .then(result => {
                po_list = result.data
                app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    }
    return po_list
}

export const savePO = async (app, po, silent=false) => {
    let save_po = null

    if (!silent) app.startLoadingIndicator("Saving Purchase Order")
    /** It's a new Purchase Order */
    if (!po._id)
        await trackPromise (
            axios.post(app.API_URI + '/purchaseorders', po)
            .then(result => {
                save_po = result.data
                if (!silent) app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    else {
    /** It's an update */
        await trackPromise (
            axios.put(app.API_URI + `/purchaseorders?po_id=${po._id}`, po)
            .then(result => {
                save_po = result.data
                if (!silent) app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    }
    return save_po
}

export const deletePO = async (app, po_id) => {
    let delete_po = null
    app.startLoadingIndicator("Deleting Purchase Order")
    await trackPromise (
        axios.delete(app.API_URI + `/purchaseorders?po_id=${po_id}`)
        .then(result => {
            delete_po = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return delete_po
}

export const getPOSettings = async (app) => {
    let po_settings = false
    const user_id = (app.client.signed_in === 'admin') ? app.client.signed_in : app.client.signed_in.id
    app.startLoadingIndicator()
    await trackPromise (
        axios.get(app.API_URI + `/settings?user_id=${user_id}&field=po`)
        .then(result => {
            if (result.data) {
                po_settings = result.data
                app.stopLoadingIndicator()
            } 
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return po_settings
}

export const savePOSettings = async (app, settings) => {
    let save_po_settings = false
    const user_id = (app.client.signed_in === 'admin') ? app.client.signed_in : app.client.signed_in.id
    app.startLoadingIndicator("Saving Purchase Oder setings")
    trackPromise (
        axios.put(app.API_URI + `/settings?user_id=${user_id}$field=po`, settings)
        .then(result => {
            save_po_settings = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return save_po_settings
}